import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";
import {
  Edit as EditIcon
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import UserProfile from "../UserProfile";
import { usePermissions } from "../../../../context/PermissionsAndFeatures/UserPermissionsContext";

const UsersTable = ({ users, onEdit, onLinkRoots, onBankPermissions, onEditDetails, refresh, onOpenActions }) => {
  const { hasPermission, loading: permissionsLoading } = usePermissions();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuUser, setMenuUser] = React.useState(null);

  // Dialog state for UserProfile
  const [selectedUserId, setSelectedUserId] = React.useState(null);
  const [profileOpen, setProfileOpen] = React.useState(false);
  
  const handleOpenMenu = (event, user) => {
    event.stopPropagation(); // ✅ منع تفعيل عرض البيانات
    setAnchorEl(event.currentTarget);
    setMenuUser(user);
  };

  const handleEditClick = (event, user) => {
    event.stopPropagation(); // ✅ منع تفعيل عرض البيانات
    onEdit(user);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuUser(null);
  };

  // فتح عرض الملف الشخصي للمستخدم - فقط عرض UserProfile داخل الديالوج
  const handleRowClick = (user) => {
    setSelectedUserId(user.id);
    setProfileOpen(true);
  };

  const handleCloseProfile = () => {
    setProfileOpen(false);
    setSelectedUserId(null);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>الاسم</TableCell>
              <TableCell>اسم المستخدم</TableCell>
              <TableCell>الدور</TableCell>
              <TableCell>الحالة</TableCell>
              <TableCell>الفروع</TableCell>
              <TableCell>إجراء</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow
                key={user.id}
                hover
                onClick={() => handleRowClick(user)}
                sx={{
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.user_name}</TableCell>
                <TableCell>{user.type}</TableCell>
                <TableCell>{user.status === 1 ? "✅ مفعل" : "❌ غير مفعل"}</TableCell>
                <TableCell>
                  {user.roots?.length > 0
                    ? user.roots.map((r) => r.name).join("، ")
                    : "لا يوجد"}
                </TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={(e) => handleEditClick(e, user)}>
                    <EditIcon />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl) && menuUser?.id === user.id}
                    onClose={handleCloseMenu}
                  >
                    {menuUser && (
                      <Box display="flex" flexDirection="column" px={1}>
                        <MenuItem
                          onClick={() => {
                            onLinkRoots(menuUser);
                            handleCloseMenu();
                          }}
                        >
                          ربط المستخدم بفروع
                        </MenuItem>
                      </Box>
                    )}
                  </Menu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog لعرض UserProfile */}
      <Dialog
        open={profileOpen}
        // منع الإغلاق عن طريق النقر على الخلفية أو الضغط على Escape
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            // تجاهل المحاولة
            return;
          }
          handleCloseProfile();
        }}
        disableEscapeKeyDown
        fullWidth
        maxWidth={false} // نترك التحكم الكامل للـ PaperProps
        PaperProps={{
          sx: {
            width: "98vw",         // زيادة العرض إلى نسبة أكبر من الشاشة
            maxWidth: "1800px",    // رفع الحد الأقصى للعرض
            height: "92vh",        // زيادة الارتفاع إلى نسبة أكبر
            maxHeight: "1200px",   // رفع الحد الأقصى للارتفاع
            borderRadius: 2,
            p: 0,
          },
        }}
      >
        <DialogTitle>
          تفاصيل المستخدم
          <IconButton
            aria-label="close"
            onClick={handleCloseProfile}
            sx={{ position: "absolute", left: 8, top: 8 }} // moved to left
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            p: 2,
            // نضمن مساحة داخلية قابلة للتمرير تتناسب مع الارتفاع الجديد
            height: "calc(92vh - 72px)",
            overflow: "auto",
          }}
        >
          {selectedUserId ? <UserProfile userId={selectedUserId} /> : null}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UsersTable;


